import { useState } from 'react'
import { JoinHomeScreen, type JoinedGame } from './JoinHomeScreen'
import { JoinRoomScreen } from './JoinRoomScreen'
import { ColorfulRoomScreen } from '../games/colorful/screens/ColorfulRoomScreen'
import { ThreeStepRoomScreen } from '../games/three-step/screens/ThreeStepRoomScreen'

type Stage =
  | { kind: 'home'; presetCode: string | null }
  | { kind: 'in-room'; game: JoinedGame; roomId: string; roomCode: string }

/**
 * Phone guest entrypoint. Lives under /join or /join/CODE. Guests sign
 * in anonymously (via JoinHomeScreen) and join the room. The code lookup
 * tells us whether this is an I'd Eat That room or a Colorful room, and
 * we route to the matching room screen.
 */
export function JoinApp() {
  const presetCode = parseRoomCode(window.location.pathname)

  const [stage, setStage] = useState<Stage>({ kind: 'home', presetCode })

  if (stage.kind === 'in-room') {
    const onLeave = () => {
      window.history.pushState(null, '', '/join')
      setStage({ kind: 'home', presetCode: null })
    }

    if (stage.game === 'colorful') {
      return <ColorfulRoomScreen roomId={stage.roomId} onExit={onLeave} />
    }
    if (stage.game === 'three_step') {
      return <ThreeStepRoomScreen roomId={stage.roomId} onExit={onLeave} />
    }
    return (
      <JoinRoomScreen
        roomId={stage.roomId}
        roomCode={stage.roomCode}
        onLeave={onLeave}
      />
    )
  }

  return (
    <JoinHomeScreen
      presetCode={stage.presetCode}
      onJoined={(game, roomId, roomCode) => {
        window.history.pushState(null, '', `/join/${roomCode}`)
        setStage({ kind: 'in-room', game, roomId, roomCode })
      }}
    />
  )
}

function parseRoomCode(path: string): string | null {
  const m = path.match(/^\/join\/?([A-Za-z0-9]+)?\/?$/)
  const code = m?.[1]
  if (!code) return null
  return code.toUpperCase()
}
